const dispatchWSAction = (store, event, payload) => { // eslint-disable-line no-unused-vars
  // TODO: hacer funcion mas escalable (que maneje 100+ actions)
  switch (event) {
    default:
      break;
  }
};

export default dispatchWSAction;
